import {BaseEntityUtils} from '../../app-common/data/BaseEntityUtils';
import {Category} from './category';

export class CategoryUtils {
  static setDefaultProperties(target: Category) {
    BaseEntityUtils.setDefaultProperties(target);
    target.name = '';
    target.shortDescription = '';
    target.longDescription = '';
  }
}
